import { useState } from 'react';
import { Link } from 'react-router-dom';
import { menuIcon } from '../../../../../configs/Icons';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import InstOption from '../../../../utils/InstOption';
import {
    CameraIcon,
    ImageUploadingIcon,
    LinkArrow,
    OptionTransparentIcon,
    ReloadGrIcon
} from '../../../../utils/SVGIcon';
import { TextCapitalize } from '../../../../utils/TextFormatter';
import { handleChangeProductLogoOpe } from '../SubscriptionsDetailsOpe';
import { useSubscriptionsDetails } from '../SubscriptionsDetailsProvider';
import SubscriptionInfoCard from './SubscriptionInfoCard';

function ButtonWrapper({ children, className, onClick }) {
    return (
        <span className="h-full !block">
            <button
                type="button"
                className={`h-[34px] block text-sm font-e text-secondary bg-[rgba(255,255,255,0.80)] backdrop-blur-[2px] rounded-5 ${className}`}
                onClick={onClick}
            >
                {children}
            </button>
        </span>
    );
}

function ActionArea({ handleReload, openModal, showMenu, setShowMenu }) {
    return (
        <div className="flex items-center gap-x-2.5 absolute top-2 right-2">
            <ButtonWrapper className="w-[34px] p-1" onClick={handleReload}>
                <ReloadGrIcon />
            </ButtonWrapper>
            <div className="relative">
                <ButtonWrapper className="w-[34px]" onClick={() => setShowMenu(!showMenu)}>
                    <span className="w-full block">
                        <OptionTransparentIcon />
                    </span>
                </ButtonWrapper>
                <InstOption showMenu={showMenu} setShowMenu={setShowMenu}>
                    {/* Change Customer Type */}
                    <button type="button" onClick={() => openModal('edit-subscription')}>
                        Edit Info
                    </button>
                    <button type="button" onClick={() => openModal('modify-version')}>
                        Modify Version
                    </button>
                    <button type="button" onClick={() => openModal('modify-start-date')}>
                        Modify Start Date
                    </button>

                    {/* Edit Customer info */}
                </InstOption>
            </div>
        </div>
    );
}

function SubscriptionDetails({ subscriptionInfo }) {
    const { id, logoUrl } = subscriptionInfo;
    const { setMessage } = useTemplate();
    const { handleReload } = useSubscriptionsDetails();
    const [isLoading, setIsLoading] = useState(false);

    const handleUpload = (e) => {
        if (!e.target.files[0]) return;
        setIsLoading(true);
        const formData = new FormData();
        formData.append('profileImage', e.target.files[0]);
        handleChangeProductLogoOpe(id, formData)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                setIsLoading(false);
                handleReload();
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.toString(0) });
                setIsLoading(false);
            });
    };

    const isProductInactive = subscriptionInfo?.status === 'inactive';

    return (
        <div className="overflow-hidden">
            <div className="size-[100px] bg-[#E6F6ED] relative rounded-full p-4 mb-4">
                <span className="w-full block">
                    {isLoading ? (
                        <ImageUploadingIcon />
                    ) : (
                        <img src={logoUrl || menuIcon.settingsWL} alt="" className="w-full block" />
                    )}
                </span>
                <label
                    type="button"
                    className={`absolute bottom-0 right-0 size-[31px] p-[7px] text-primary bg-white rounded-full cursor-pointer ${
                        isProductInactive ? 'invisible' : ''
                    }`}
                >
                    <input
                        type="file"
                        className="hidden"
                        onChange={handleUpload}
                        accept="image/png, image/jpeg, image/jpg"
                    />
                    <CameraIcon />
                </label>
            </div>
            <div className="flex flex-col ite gap-1">
                <div className="flex flex-row items-center gap-2.5 relative text-primary text-2xl font-medium whitespace-nowrap  text-ellipsis overflow-hidden">
                    <span className="overflow-hidden text-ellipsis">
                        {subscriptionInfo?.subscriptionName}
                    </span>
                    <Link
                        to={subscriptionInfo?.applicationInfo?.website}
                        target="_blank"
                        className="w-4 -ml-1 -mt-5"
                    >
                        <span>
                            <LinkArrow className="text-black hover:text-white" />
                        </span>
                    </Link>

                    <span className="bg-warning text-sm text-white py-px px-2.5 rounded-[4px] max-h-[22px]">
                        {TextCapitalize(subscriptionInfo?.applicationInfo?.status) || '--'}
                    </span>
                </div>
                <p className="text-sm text-primary">
                    <span>{subscriptionInfo?.applicationInfo?.description || '-------------'}</span>
                </p>
                <div>
                    <div className="flex gap-x-2 text-base text-primary">
                        <div className="whitespace-nowrap">
                            <span>Name:</span>
                        </div>
                        <div className="whitespace-nowrap">
                            <span>{subscriptionInfo.customerInfo.fullName || '------'}</span>
                        </div>
                    </div>
                    <div className="flex gap-x-2 text-base text-primary">
                        <div className="whitespace-nowrap">
                            <span>Email:</span>
                        </div>
                        <div className="whitespace-nowrap">
                            <span>{subscriptionInfo.customerInfo.primaryEmail || '------'}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function SubscriptionInfo({ data, handleReload, openModal }) {
    const [showMenu, setShowMenu] = useState(false);

    return (
        <div
            className={`product-bg relative w-full h-auto min-h-[250px] p-2.5 mb-4 2xl:flex justify-between 2xl:gap-3 ${
                data?.demo ? 'placeholder-mode' : ''
            }`}
        >
            {/* product information */}
            <div className="flex flex-1 items-center pl-5 relative z-20 mb-9">
                <SubscriptionDetails subscriptionInfo={data} />
            </div>

            {/* product info in separate cards */}
            <div className="flex items-end">
                <SubscriptionInfoCard data={data} />
            </div>

            {/* section action buttons */}
            <ActionArea
                handleReload={handleReload}
                openModal={openModal}
                showMenu={showMenu}
                setShowMenu={setShowMenu}
            />
        </div>
    );
}

export default SubscriptionInfo;
